import { IconButton, Tooltip } from "@mui/material";
import { FC, memo } from "react";
import {
  FaVideo,
  FaVideoSlash,
  FaVolumeMute,
  FaVolumeUp,
} from "react-icons/fa";
import styled from "styled-components";
import { useRemoteParticipant } from "../../hooks/useRemoteParticipant";

const RemoteOptionsWrapper = styled("div")`
  position: absolute;
  bottom: 8px;
  left: 8px;
  z-index: 5;
  display: flex;
  flex-flow: column;
  gap: 8px;
`;

const ActionIconButton = styled(IconButton)`
  && {
    background-color: rgba(0, 0, 0, 0.7);
    width: 40px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 1px solid rgba(255, 255, 255, 0.644);

    svg {
      fill: rgba(255, 255, 255, 0.404);
    }
    &:hover {
      background-color: rgba(0, 0, 0, 0.8);
    }
  }
`;

const RemoteParticipantOptions: FC = () => {
  const {
    localRemoteVideoOff,
    localRemoteAudioOff,
    handleLocalRemoteVideo,
    handleLocalRemoteAudio,
  } = useRemoteParticipant();

  return (
    <RemoteOptionsWrapper>
      <Tooltip
        title={localRemoteVideoOff ? "Habilitar câmera" : "Desabilitar câmera"}
        arrow
      >
        <ActionIconButton
          onClick={() => handleLocalRemoteVideo(!localRemoteVideoOff)}
        >
          {localRemoteVideoOff ? (
            <FaVideoSlash size={25} />
          ) : (
            <FaVideo size={25} />
          )}
        </ActionIconButton>
      </Tooltip>

      <Tooltip
        title={localRemoteAudioOff ? "Habilitar áudio" : "Desabilitar áudio"}
        arrow
      >
        <ActionIconButton
          onClick={() => handleLocalRemoteAudio(!localRemoteAudioOff)}
        >
          {localRemoteAudioOff ? (
            <FaVolumeMute size={25} />
          ) : (
            <FaVolumeUp size={25} />
          )}
        </ActionIconButton>
      </Tooltip>
    </RemoteOptionsWrapper>
  );
};

export default memo(RemoteParticipantOptions);
